<div [formGroup]="form" layout-vertical>
  <div layout-vertical>
    <rt-heading variant="heading block">
      {{ 'app.account.email_notifications' | translate }}
    </rt-heading>
    <span>{{ 'app.account.email_notifications_info' | translate }}</span>
  </div>
  <div layout margin-top-small>
    <rt-select
      [options]="intervalOptions"
      [hasSearch]="false"
      [includeEmptyOption]="false"
      [hasInputTrigger]="true"
      class="interval-select"
      formControlName="interval"
      margin-right
    ></rt-select>
    <div class="btn-container" layout layout-align-items-center>
      @if (
        intervalControl.value === AdminReportInterval.Week ||
        intervalControl.value === AdminReportInterval.Day
      ) {
        @if (intervalControl.value === AdminReportInterval.Week) {
          <span>{{ 'app.account.on' | translate }}</span>
          <rt-select
            [options]="weekDaysOptions"
            [hasSearch]="false"
            [includeEmptyOption]="false"
            [hasInputTrigger]="true"
            [noMaxHeight]="true"
            formControlName="day"
            class="picker picker__day"
            margin-lr
          ></rt-select>
        }

        <span>{{ 'app.account.at' | translate }}</span>
        <rt-schedule-time-picker
          [time]="form.get('time')!.value"
          [fullWidth]="true"
          [timeInterval]="0"
          (timeChange)="onTimeChange($event)"
          margin-left
        >
        </rt-schedule-time-picker>
      }
    </div>
  </div>
</div>
